import { css } from 'linaria';

export const componentContainer = css`
  display: block;
`;

export const contentContainer = css`
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow: hidden;
  border-radius: 4px;
`;

export const contentContainerLarge = css`
  width: 864px;
`;

export const contentContainerMedium = css`
  width: 672px;
`;

export const contentContainerTablet = css`
  width: 100%;
  overflow-x: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const contentContainerMobile = css`
  width: 100%;
  overflow-x: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const contentContainerMLine = css`
  flex-wrap: wrap;
`;

export const tileContainer = css`
  display: block;
  flex-grow: 0;
  flex-shrink: 0;

  width: 88px;
  height: 88px;
  margin-right: 8px;
  border-radius: 4px;
`;

export const tileContainerMLine = css`
  margin-bottom: 8px;
`;

export const showMoreButton = css`
  position: absolute;
  top: 0;
  right: 8px;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  width: 88px;
  font-weight: 500;
  font-size: 16px;

  font-style: normal;
  line-height: 22px;
  color: var(--text-invert);
  background-color: rgba(46, 50, 61, 0.5);
  border: none;
  border-radius: 4px;

  cursor: pointer;
`;

export const tileImgTileContent = css`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
`;
